import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { routes } from "router"
import { isEmbeddedContext } from "helpers/embedded"
import { generateGuideProfileUrl } from "utils/host-urls"

/**
 * Wraps guide identity (avatar / name / rating) in a link to that guide's
 * public profile.
 *
 * Inside the booking widget the app runs in an iframe on the host's page, so an
 * in-app route would navigate the frame and strand the user inside the widget.
 * There we link out to the absolute URL on our own domain in a new tab instead.
 *
 * Renders the children unwrapped when no slug is available, so callers can pass
 * the guide through unconditionally.
 */
const GuideProfileLink = ({ slug, className, title, children }) => {
  if (!slug) return <div className={className}>{children}</div>

  if (isEmbeddedContext()) {
    return (
      <a href={generateGuideProfileUrl(slug)} target="_blank" rel="noopener noreferrer" className={className} title={title}>
        {children}
      </a>
    )
  }

  return (
    <Link to={routes.proGuideProfilePath({ slug })} className={className} title={title}>
      {children}
    </Link>
  )
}

GuideProfileLink.propTypes = {
  slug: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default GuideProfileLink
